import BN from "bn.js"
import { Session } from "@chromia/ft4";

import { TypedGtxClient, iChrParams } from "./chromiaInterfaces";
import { BigNumber } from "../../entities/BigNumber";
import { Token } from "../../entities/Token";


export interface iReduxState {
    app: iApp_state,
    modals: iModals_state
}

export interface iApp_state {
    clientAddr: string | null;
    closedPeriod: boolean,
    provider: iWeb3Provider | null;
    periods: iPeriod[] | null,
    pool: pool | null,
    token: string,
    vault: pool | null,
    vaults: iVault[],
    stVault: iVault | null,
    ltVault: iVault | null,
    params: iChrParams | null,
    tokens: Token[],
    clientInfo: iClientInfo | null,
    accessToken: string | null,
    priceGainInfo: iPriceGainInfo | null,
    session: Session | null,
    chrClientAddr: string | null,
    gtxClient: TypedGtxClient | null,
    balances: iBalances | null,
    transactionStatus: transactionStatus | null,
    isIniting: boolean,
    fToken: string
}

export interface iModals_state {
    buttonBlock: boolean,
    infoModal: boolean,
    infoModalMsg: string,
    withdrawModal: boolean,
    depositModal: boolean,
    transactionModal: boolean,
    historyModal: boolean,
    changeDepositModal: boolean,
    changeRequestType: 'sell' | 'buy' | null,
    warningRequestModal: boolean,
    priceHistoryModal: boolean
}


export interface iWeb3Provider {  
    isMetaMask?: boolean,
    disconnect?: 
        () => void,
    on?: (
        event: string, 
        callback: Function
    ) => Function,
    once?: ( 
        event: string, 
        callback: Function
    ) => Function,
    removeListener?: (
        event: string, 
        callback: Function
    ) => Function
}

export interface iPriceGainInfo {
    tablePercent: BigNumber[],
    tablePrice: any,
    tableTime: any
}

export interface iPeriod {
    num: number,
    beg_time: number,
    beg_price: number,
    ltv_c: string,
    stv_c: string,
    hedg_c: string,
    started_time: number,
    ended_time: number;
    client_ltv_b: BigInt,
    client_ltv_b_dec: string,
    client_ltv_e: BigInt,
    client_ltv_e_dec: string,
    client_stv_b: BigInt,
    client_stv_b_dec: string,
    client_stv_e: BigInt,
    client_stv_e_dec: string,
    end_price: string,
    h_ltv_fee: BigInt,
    h_ltv_fee_dec: string,
    h_stv_fee: BigInt,
    h_stv_fee_dec: string,
    hedg_fee: BigInt, 
    hedg_fee_dec: string,
    hedg_ltv: BigInt,
    hedg_ltv_dec: string,
    hedg_stv: BigInt, 
    hedg_stv_dec: string,
    o_ltv_fee: BigInt,
    o_ltv_fee_dec: string,
    o_stv_fee: BigInt,
    o_stv_fee_dec: string
}

export interface iClientInfo {
	[type: string]: iRequest
}

export interface iRequest {
    from: Buffer,
	type: string,
	amt: BigNumber,
	amt_dec: string,
	fin_per : number
}

export interface iVault {
    client_depo_req: BigNumber,
    client_depo_req_dec: string,  
    client_ft: BigNumber,
    client_ft_dec: string,
    client_wd_req: BigNumber,
    client_wd_req_dec: string,
    ft_lim: BigNumber,
    ft_lim_dec: string,
    hedger_ft: BigNumber,
    hedger_ft_dec: string,
    name: string,
    tok: string
}

export interface iBalances {
    lt: BigNumber,
    st: BigNumber,
    ft: BigNumber
}

export interface iHedgerInfo {
	fee: string,
	req_ft: BigNumber,
	req_ft_dec: string,
	wd_per: string,
	use_ft: BigNumber,
	use_ft_dec: string,
	fee_amt: BigNumber,
	fee_amt_dec: string;
	from: Buffer,
}

export type pool = 'Long' | 'Short';
export type transactionStatus = 'succes' | 'error' | 'progress';

export const zeroBN = new BN(0);
export const ETHval = new BN('1000000000000000000');  // 10**18